import React from 'react';
import { useTranslation } from 'react-i18next';

import { ApplicationContent } from '../../components/layout/ApplicationContent/ApplicationContent';
import DocumentOverview from '../../components/Document/DocumentOverview';
import PageTitle from '../../components/layout/PageTitle/PageTitle';

const OverviewReports = () => {
    const { t } = useTranslation();

    return (
        <ApplicationContent>
            <PageTitle headline={t('documentTitles.overviewReports')} />
            <DocumentOverview />
        </ApplicationContent>
    )
}

export default OverviewReports;